// extracted by mini-css-extract-plugin
export default {"pickup":"product-list-pickup_pickup__RCCkc","pickup_heading":"product-list-pickup_pickup_heading__fmMun","pickup_heading_label":"product-list-pickup_pickup_heading_label__mc5Nh"};